import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Switch from "react-switch";
import lodash from "lodash";
import moment from "moment";
import { DATETIME } from "../../../../utils/dateFormats";

const CheckedIn = ({ inServiceUser }) => (
  inServiceUser && inServiceUser.check_in_at ? (
    <div style={{ float: "right" }}>
      {moment(new Date(inServiceUser.check_in_at)).format(DATETIME)}
    </div>
  ) : null);

class Employee extends React.Component {
  get employeeSkill() {
    const { employee, skill, employeesSkills } = this.props;

    return lodash.find(employeesSkills, {
      user_id: employee.id, in_service_category_skill_id: skill && skill.id
    });
  }

  get checked() {
    const employeeSkill = this.employeeSkill;
    return employeeSkill ? employeeSkill.status : false;
  }

  get notes() {
    const employeeSkill = this.employeeSkill;
    return employeeSkill ? (employeeSkill.notes || "") : "";
  }

  handleToggle = status => {
    const { employee, skill, onUpdate } = this.props;
    onUpdate(employee.id, skill.id, { status, notes: this.notes }, true);
  };

  handleChangeNotes = e => {
    const { employee, skill, onUpdate } = this.props;
    onUpdate(employee.id, skill.id, { status: this.checked, notes: e.target.value }, true);
  };

  render() {
    const { employee, isAdmin, inServiceUser, onCheckAll } = this.props;
    const checked = this.checked;

    return (
      <Fragment>
        <tr>
          <td colSpan={2}>
            <CheckedIn inServiceUser={inServiceUser}/>
            <div style={{ paddingBottom: 10 }}>
              {employee.full_name_reverse}
              {isAdmin ? (
                <a
                  href="javascript:void(0);"
                  onClick={() => { onCheckAll(employee.id, true) }}
                >
                  <i className="material-icons">done_all</i>
                </a>
              ) : null}
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ width: 80 }}>
            {isAdmin ? (
              <Switch
                checked={checked}
                onChange={this.handleToggle}
                onColor="#DADCE1"
                onHandleColor="#3A4590"
                handleDiameter={25}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={48}
                className="react-switch"
              />
            ) : checked ?
              <i className="material-icons">done</i> :
              null
            }
          </td>
          <td>
            <textarea
              className="form-control"
              placeholder="Notes..."
              disabled={!isAdmin}
              value={this.notes}
              onChange={this.handleChangeNotes}
            />
          </td>
        </tr>
      </Fragment>
    );
  }
}

Employee.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  employee: PropTypes.object.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  skills: PropTypes.array.isRequired,
  inServiceUser: PropTypes.object,
  onUpdate: PropTypes.func,
  onCheckAll: PropTypes.func.isRequired
};

export default Employee;
